import React, { Fragment, memo, useMemo } from 'react';
import Button from '@material-ui/core/Button';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { setSidebarToggle } from '../../reducers/ThemeOptions';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setWatchlistDialog } from 'reducers/Watchlist';
import { extractItemsByUserPlan } from 'global/GlobalActions';
import headerNavLinks from 'layout-components/HeaderMenuSimple/headerNavLinks';
import { makeStyles } from '@material-ui/core';

const HeaderMenu = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const allowedHeaderLinks = useMemo(() => extractItemsByUserPlan(null, headerNavLinks), []);

  const goToRoutePage = path => {
    if (location.pathname === path) return;
    if (path === '/home' || path === '/watchlist') {
      dispatch(setSidebarToggle(true));
    }
    history.push(path);
  };

  return (
    <div style={{ display: 'flex' }}>
      {allowedHeaderLinks.map(route => (
        <Fragment key={route.path}>
          {route.path === '/guideline' ? (
            <Button
              size="medium"
              color="inherit"
              className={classes.marginX}
              onClick={() => dispatch(setWatchlistDialog(true))}>
              Watchlist
            </Button>
          ) : null}
          <Button
            size="medium"
            color="inherit"
            onClick={() => goToRoutePage(route.path)}
            className={clsx(classes.marginX, { [classes.active]: location.pathname === route.path })}>
            {route.label}
          </Button>
        </Fragment>
      ))}
    </div>
  );
};

export default memo(HeaderMenu);

const useStyles = makeStyles({
  marginX: { margin: '0 0.1rem', whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 },
  active: { backgroundColor: 'rgba(255, 255, 255, 0.07)' },
});
